import * as Sentry from "@sentry/nextjs";
import React, { useEffect } from "react";
import { NextPage } from "next";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import { IErrorPageProps } from "@Interfaces/pages/Error";
import {
    getSessionStorageItem,
    removeSessionStorageItem,
} from "repoV2/utils/common/storage/getterAndSetters";
import { Button } from "repoV2/components/common/Button";
import { SESSION_STORAGE_KEYS } from "repoV2/features/Common/modules/Storage/Storage.constants";
import styles from "./ReportError.module.scss";

const ReportError: NextPage<IErrorPageProps> = () => {
    useEffect(() => {
        if (!process.env.NEXT_PUBLIC_ENABLE_DEBUG_LOGS) return;
        const customError = getSessionStorageItem(
            SESSION_STORAGE_KEYS.REDIRECTION_ERROR
        );

        if (!customError) return;
        Sentry.captureMessage(JSON.stringify(customError.error));
        removeSessionStorageItem(SESSION_STORAGE_KEYS.REDIRECTION_ERROR);
    }, []);

    return (
        <>
            <div className={styles.container}>
                <ErrorOutline className={`${styles.erroricon} mb-4`} />
                <h1 className={styles.heading}>Oops! Something Went Wrong</h1>
                <p className={styles.message}>
                    We&apos;re sorry, but something went wrong. Please try
                    refreshing the page or come back later.
                </p>
                <Button
                    className="mt-4"
                    onClick={() => {
                        window.location.href = "/";
                    }}
                >
                    Go to Home
                </Button>
            </div>
        </>
    );
};

export default ReportError;
